import { START_LOADING, GET_CONSULTANTS, GET_CONSULTANTS_PDF, GET_BARETER_PLANS, GET_SUMMARY, STOP_LOADING, ERROR } from "../beraterplanAction/types";


const INITIAL_STATE = {
  loading: false,
  success: false
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_CONSULTANTS:
      return {
        ...state,
        consultant_list: action.payload,
        success: false,
        loading: false
      }
    case GET_CONSULTANTS_PDF:
      return {
        ...state,
        consultant_pdf: action.payload,
        success: false,
        loading: false
      }
    case GET_BARETER_PLANS:
      return {
        ...state,
        bareter_plan: action.payload,
        success: false,
        loading: false
      }
    case GET_SUMMARY:
      return {
        ...state,
        summary_sum: action.payload,
        success: false,
        loading: false
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }
    case ERROR:
      return {
        ...state,
        error_message: action.payload,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
}